import Vue from "vue";
import EntityMixin from "@/mixins/EntityMixin";

Vue.mixin(EntityMixin);